import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getUnidades = async () => {
  const url = API_CONSTANT_MAP.unidade;
  return requestApi.get(url);
};

export const getUnidadeById = async (id: string | number) => {
  const url = `${API_CONSTANT_MAP.unidade}/${id}`;
  return requestApi.get(url);
};

export const postUnidade = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.unidade, payload);
};
